// extracted by mini-css-extract-plugin
module.exports = {"overviewTab":"LocationTabsOverview_overviewTab__210qL","chart":"LocationTabsOverview_chart__3kXbN","storage":"LocationTabsOverview_storage__3Ed7M"};